import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      We're happy to welcome you between 12:00 and 22:00.
    </div>
  );
};

export default Footer;
